export const prod = true;

export const url_prod = 'https://service-provisorio.premiumclube.org.br/';
export const url_homo = 'http://service.hm.premiumclube.org.br/';

export const token = '0f4338e84b6a2d75bd17dd6eeec0f24265e46773152236d8dbcfaa8e73b9be93';